import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import axios from "axios";
import * as XLSX from "xlsx";

import KioskHeader from "../kiosk/component/common/kioskHeader";

import { Container } from "../kiosk/component/styled/common";
import { KioskSalesCheck } from "../kiosk/component/styled/salesCheck";
import { sales } from "../kiosk/component/function/kiosk";
import { useDisableScroll } from "../../../hooks/useDisableScroll";

import SalesDetailModal from "./component/kioskSalesCheck/salesDetailModal";
import CalendarInfo from "./component/kioskSalesCheck/calendarInfo";
import Calendar from "./component/kioskSalesCheck/calendar";
import { useSelector } from "react-redux";
import { checkKioskCond } from "../dashboard/component/function/dashboard";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";

const BbdabangSalesCheck = () => {
  useDisableScroll();

  const navigate = useNavigate();

  const user = useSelector((state) => state?.user?.data[0]);
  const company = useSelector((state) => state?.company?.data);

  const calendarRef = useRef();

  const [payTotals, setPayTotals] = useState({});
  const [data, setData] = useState([]);
  const [events, setEvents] = useState([]);
  const [onDate, setOnDate] = useState(moment().format("YYYY-MM-DD"));
  const [onPrevDate, setOnPrevDate] = useState(moment().format("YYYY-MM-DD"));
  const [openModal, setOpenModal] = useState(false);
  const [detail, setDetail] = useState({});
  const [total, setTotal] = useState(0);

  useEffect(() => {
    if (!checkKioskCond(company)) {
      toast.error("접근 권한이 없습니다.", { toastId: "no-access" });
      navigate("/mypage");
      return;
    }

    getSalesInfo(onDate);
  }, []);

  useEffect(() => {
    updateCalendarView(onDate);
    if (onDate && (!onPrevDate || !moment(onDate).isSame(onPrevDate, "month"))) {
      getSalesInfo(onDate);
    }
    setOnPrevDate(onDate);
  }, [onDate]);

  // 날짜 변경
  const updateCalendarView = (date) => {
    if (calendarRef.current) {
      const calendarApi = calendarRef.current.getApi();
      calendarApi.gotoDate(date);
    }
  };

  // 매출 조회 - 월별
  const getSalesInfo = async (date) => {
    const url = "/api/sales-info/month";
    const body = {
      month: moment(date).format("MM"),
      year: moment(date).format("YYYY"),
      point: "baseball",
    };

    try {
      const res = await axios.post(url, body);
      if (res.status === 200) {
        setData(res.data);
        const event = transformEvents(res.data);
        setEvents(event);
      } else {
        setData([]);
        setEvents([]);
        setTotal(0);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // 풀캘린더 형식에 변경
  const transformEvents = (origin) => {
    const events = [];
    let month = 0;
    const payTypeSum = {};

    origin.forEach((item) => {
      let totalAmount = 0;
      const paymentTypes = Object.keys(item.paymentTypeAmount);

      paymentTypes.forEach((type) => {
        const amount = item.paymentTypeAmount[type];
        const cancel = item.paymentTypeCancelAmount[type];

        const total = cancel ? amount - cancel : amount;
        totalAmount += total;

        if (!payTypeSum[type]) {
          payTypeSum[type] = 0;
        }
        payTypeSum[type] += total;

        events.push({
          title: `${formatNumber(total)}`,
          start: item.createdAt,
          textColor: sales[type].color || "#000",
          payType: sales[type].type,
          label: type,
          allDay: true,
        });
      });

      events.push({
        id: `total-${item.createdAt}`,
        title: `${formatNumber(totalAmount)}`,
        start: item.createdAt,
        label: "3",
        textColor: "#000",
        payType: "total",
        allDay: true,
      });

      month += totalAmount;
    });

    setTotal(month);
    console.log(payTypeSum);
    setPayTotals(payTypeSum);
    return events;
  };

  const handleEventClick = (date) => {
    const event = data.find((item) => item.createdAt === date);
    if (!event) return;

    setDetail(event);
    setOpenModal(true);
  };

  const handleDateClick = async (date) => {
    const target = moment(date).format("YYYY-MM-DD");
    setOnDate(target);
  };

  const downloadExcel = () => {
    const sheetData = events.map((item, index) => ({
      결제날짜: moment(item.start).format("YYYY-MM-DD"),
      결제수단: sales[item.label]?.label || "",
      결제금액: item.title + "원",
    }));

    const worksheet = XLSX.utils.json_to_sheet(sheetData);

    worksheet["F1"] = { t: "s", v: "총합계" };
    worksheet["G1"] = { t: "n", v: total ? total : 0 + "원" };

    const range = XLSX.utils.decode_range(worksheet["!ref"]);
    range.e.c = Math.max(range.e.c, 6);
    worksheet["!ref"] = XLSX.utils.encode_range(range);

    worksheet["!autofilter"] = { ref: `A1:D${events.length + 1}` };

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet);

    const fileName = `${moment(onDate).format("YYYYMM")}.xlsx`;
    XLSX.writeFile(workbook, fileName);
  };

  return (
    <Container>
      <KioskSalesCheck className="baseball">
        <KioskHeader title={"매출관리"} />
        <div className="content">
          <CalendarInfo
            onDate={onDate}
            handleDateClick={handleDateClick}
            total={total}
            downloadExcel={downloadExcel}
            payTotals={payTotals}
          />
          <Calendar calendarRef={calendarRef} handleEventClick={handleEventClick} events={events} />
        </div>
      </KioskSalesCheck>
      {openModal && <SalesDetailModal setOpenModal={setOpenModal} detail={detail} />}
    </Container>
  );
};

export default BbdabangSalesCheck;
